import { connect } from 'react-redux'
import ActivateUserPage from '../components/ActivateUserPage'
import PermissionDenied from '../../../../../../../../Unauthorized/components/PermissionDenied'
import { actions } from '../modules/ActivateUser'

const mapStateToProps = (state, ownProps) => {
  const { studyVersionID } = ownProps?.params || {}
  return { ...state.activateUser, isPasswordChange: false, studyVersionID }
}

const mapDispatchToProps = actions

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(props => {
  if (props.userToken) {
    return ActivateUserPage(props)
  }
  return ActivateUserPage(props)
})
